export enum PfComponents {
    CtBody = 'CtBody',
    CtHeader = 'CtHeader',
    CtRow = 'CtRow',
    CtColumn = 'CtColumn',
    CtInputText = 'CtInputText',
    CtFilterWindow = 'CtFilterWindow',
    CtCustomSelect = 'CtCustomSelect',
    CtMessage = 'CtMessage',
    CtMessageContainer = 'CtMessageContainer',
    CtProgressBar = 'CtProgressBar',
    CtStepperItem = 'CtStepperItem',
    CtRegex = 'CtRegex',
    CtRadioContainer = 'CtRadioContainer',
    CtButton = 'CtButton',
    CtDialog = 'CtDialog',
    CtButtonCompressedContainer = 'CtButtonCompressedContainer'
}